<template>
  <div class="running-pill">
    <span v-if="showLabel">RUNNING</span>
    <div class="running-pill__dot"></div>
  </div>
</template>

<script>
export default {
  name: 'RunningPill',
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<style lang="scss">
.running-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-family: var(--font-book);
  font-style: normal;
  font-weight: 450;
  font-size: rem(12px);
  line-height: rem(14px);
  color: var(--white);
  padding: 8px 10px;
  background: var(--charcoal);
  border-radius: 30px;
  &__dot {
    height: 13px;
    width: 13px;
    border-radius: 50%;
    background: var(--positive-light);
    box-shadow: var(--positive-light-shadow);
  }
}
</style>
